// Map a free-text platform/contact-type string onto one of the brand social
// glyph kinds, or null when it isn't a recognized social account.
export const SOCIAL_KINDS: readonly string[] = ['x', 'twitter', 'instagram', 'facebook', 'linkedin', 'tiktok'];

export function normalizeSocialKind(value?: string | null): string | null {
  if (!value) return null;
  const v = value.toLowerCase();
  if (v.includes('twitter') || v === 'x') return 'x';
  for (const k of ['instagram', 'facebook', 'linkedin', 'tiktok']) {
    if (v.includes(k)) return k;
  }
  return null;
}
